import React from 'react';

export default function FullscreenIcon2({
  width = 28,
  height = 28,
  className,
  style,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <g clipPath="url(#clip0)">
        <rect x="2" y="2" width="24" height="24" fill="white" />
        <path
          d="M21.5887 7.6322L16.2764 12.9225C15.4312 13.575 14.4305 12.5738 15.083 11.7292L20.3733 6.41683H17.8845C17.8609 6.41683 17.5792 6.28121 17.5383 6.25346C16.8906 5.81046 17.2158 4.75218 18.0007 4.73019C19.4454 4.82654 21.0457 4.60661 22.4721 4.73019C22.9329 4.76999 23.2355 5.07317 23.2759 5.53398C23.3994 6.95985 23.1795 8.56062 23.2759 10.0053C23.2539 10.7903 22.1956 11.1155 21.7526 10.4677C21.7248 10.4269 21.5892 10.1452 21.5892 10.1216V7.63273L21.5887 7.6322Z"
          fill="currentColor"
        />
        <path
          d="M7.75187 21.4682H10.2407C10.2543 21.4682 10.458 21.5525 10.4916 21.5698C11.2414 21.9604 10.9702 23.1235 10.1245 23.1549C8.67976 23.0585 7.07951 23.2784 5.65312 23.1549C5.19284 23.1151 4.88965 22.8119 4.84933 22.3511C4.72575 20.9252 4.94568 19.3244 4.84933 17.8797C4.87132 17.0948 5.9296 16.7696 6.3726 17.4173C6.40035 17.4582 6.53598 17.7399 6.53598 17.7635V20.2523L11.7698 15.04C12.5866 14.4054 13.6114 15.3935 12.9631 16.2334L7.75082 21.4672L7.75187 21.4682Z"
          fill="currentColor"
        />
        <path
          d="M24.1484 26H3.85159C2.83049 26 2 25.1695 2 24.1484V3.85159C2 2.83049 2.83049 2 3.85159 2H24.1484C25.1695 2 26 2.83049 26 3.85159V24.1484C26 25.1695 25.1695 26 24.1484 26ZM3.85159 3.3091C3.55259 3.3091 3.3091 3.55259 3.3091 3.85159V24.1484C3.3091 24.4474 3.55259 24.6909 3.85159 24.6909H24.1484C24.4474 24.6909 24.6909 24.4474 24.6909 24.1484V3.85159C24.6909 3.55259 24.4474 3.3091 24.1484 3.3091H3.85159Z"
          fill="currentColor"
        />
      </g>
      <rect x="1" y="1" width="26" height="26" stroke="white" strokeWidth="2" />
      <defs>
        <clipPath id="clip0">
          <rect x="2" y="2" width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
